import RenameIcon from "../style/rename.svg";
import MoveIcon from "../style/update.svg";
import DeleteIcon from "../style/delete.svg";
import DownloadIcon from "../style/download.svg";
import PreviewIcon from "../style/preview.png";
import ShareIcon from "../style/share.svg";
import ActivityIcon from "../style/activity.svg";
import EditAndResendIcon from "../style/edit_resend.svg";
import SignIcon from "../style/sign.svg";
import GenerateLinkIcon from "../style/generateLink.png";

export const folderOptions = [
  {
    name: "Rename",
    src: RenameIcon,
    id: "rename",
  },
  // {
  //   name: "Move to",
  //   src: MoveIcon,
  //   id: "moveto",
  // },
  {
    name: "Delete",
    src: DeleteIcon,
    id: "delete",
  },
];
//completed document activity
export const completedDocumentsActivity = [
  {
    name: "Download",
    src: DownloadIcon,
    id: "download",
  },
  {
    name: "Preview",
    src: PreviewIcon,
    id: "preview",
  },
  {
    name: "Turn to Template",
    src: MoveIcon,
    id: "TurnToTemplate",
  },
  {
    name: "Share",
    src: ShareIcon,
    id: "share",
  },
  {
    name: "Activity",
    src: ActivityIcon,
    id: "activity",
  },
  {
    name: "Delete",
    src: DeleteIcon,
    id: "delete",
  },
];
// awaitign document activity
export const awaitingDocumentActivity = [
  {
    name: "Preview",
    src: PreviewIcon,
    id: "preview",
  },
  // {
  //   name: "Move to",
  //   src: MoveIcon,
  //   id: "moveto",
  // },
  {
    name: "Edit & Resend",
    src: EditAndResendIcon,
    id: "editandresend",
  },
    {
    name: "Turn to Template",
    src: MoveIcon,
    id: "TurnToTemplate",
  },
  {
    name: "Send Reminder",
    src: SignIcon,
    id: "sendreminder",
  },
  {
    name: "Activity",
    src: ActivityIcon,
    id: "activity",
  },
  {
    name: "Generate signing link",
    src: GenerateLinkIcon,
    id: "generatesignlink",
  },
  {
    name: "Delete",
    src: DeleteIcon,
    id: "delete",
  },
];

//draft document activity
export const draftDocumetsActivity = [
  {
    name: "Rename",
    src: RenameIcon,
    id: "rename",
  },
  // {
  //   name: "Move to",
  //   src: MoveIcon,
  //   id: "moveto",
  // },
    {
    name: "Turn to Template",
    src: MoveIcon,
    id: "TurnToTemplate",
  },
  {
    name: "Edit & Resend",
    src: EditAndResendIcon,
    id: "editandresend",
  },

  {
    name: "Activity",
    src: ActivityIcon,
    id: "activity",
  },
  {
    name: "Delete",
    src: DeleteIcon,
    id: "delete",
  },
];
export const receivedDocumentsActivity = [
  {
    name: "Sign",
    src: SignIcon,
    id: "sign",
  },
    {
    name: "Turn to Template",
    src: MoveIcon,
    id: "TurnToTemplate",
  },
  // {
  //   name: "Move to",
  //   src: MoveIcon,
  //   id: "moveto",
  // },
  {
    name: "Delete",
    src: DeleteIcon,
    id: "delete",
  },
];

// Delete document activity
export const deleteDocumentsActivity = [
  // {
  //   name: "Move to",
  //   src: MoveIcon,
  //   id: "moveto",
  // },
  {
    name: "Delete Permanentaly",
    src: DeleteIcon,
    id: "deletepermanently",
  },
];
// Voided document activity
export const voidedDocumentsActivity = [
  // {
  //   name: "Move to",
  //   src: MoveIcon,
  //   id: "moveto",
  // },
    {
    name: "Turn to Template",
    src: MoveIcon,
    id: "TurnToTemplate",
  },
  {
    name: "Edit & Resend",
    src: EditAndResendIcon,
    id: "editandresend",
  },
  {
    name: "Delete",
    src: DeleteIcon,
    id: "delete",
  },
];
